import { z } from 'zod';
// =============================================================================
// Schemas de input/output das rotas de auth (M1.5)
// Compartilhado entre apps/api (validação) e frontends (forms tipados via @pnl/sdk)
// =============================================================================
export const passwordSchema = z
    .string()
    .min(8, 'Senha precisa ter ao menos 8 caracteres')
    .max(128, 'Senha muito longa')
    .refine((s) => /[A-Z]/.test(s), 'Inclua ao menos uma letra maiúscula')
    .refine((s) => /[a-z]/.test(s), 'Inclua ao menos uma letra minúscula')
    .refine((s) => /[0-9]/.test(s), 'Inclua ao menos um número');
export const signupInputSchema = z.object({
    email: z.string().email().toLowerCase(),
    password: passwordSchema,
    fullName: z.string().min(2).max(120),
});
export const loginInputSchema = z.object({
    email: z.string().email().toLowerCase(),
    password: z.string().min(1),
    // 2FA: opcional no primeiro request; se obrigatório, retornamos 401 com challenge
    twoFactorCode: z
        .string()
        .regex(/^\d{6}$/)
        .optional(),
});
export const refreshInputSchema = z.object({
    refreshToken: z.string().min(1),
});
export const logoutInputSchema = z.object({
    refreshToken: z.string().min(1),
});
export const requestPasswordResetSchema = z.object({
    email: z.string().email().toLowerCase(),
});
export const confirmPasswordResetSchema = z.object({
    token: z.string().min(10),
    newPassword: passwordSchema,
});
export const verifyEmailSchema = z.object({
    token: z.string().min(10),
});
export const resendVerificationSchema = z.object({
    email: z.string().email().toLowerCase(),
});
// =============================================================================
// 2FA (M1.6)
// =============================================================================
export const totpActivateInputSchema = z.object({
    code: z.string().regex(/^\d{6}$/, 'Código deve ter 6 dígitos'),
});
export const totpDisableInputSchema = z.object({
    code: z.string().regex(/^\d{6}$/, 'Código deve ter 6 dígitos'),
});
//# sourceMappingURL=auth.js.map